import React from 'react'

export default function CEmission({ style }: any) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.53425 0C4.9606 0 3.68491 1.2757 3.68491 2.84935C3.68491 4.22496 4.65976 5.37271 5.95627 5.63986C5.32252 5.25916 4.90605 4.61626 4.90605 3.88724C4.90605 2.71824 5.97673 1.7705 7.29747 1.7705C8.19314 1.7705 8.97387 2.2064 9.3836 2.85154V2.84935C9.3836 1.2757 8.1079 0 6.53425 0ZM2.84934 2.61641C1.27569 2.61641 0 3.89209 0 5.46575C0 7.0394 1.27569 8.31509 2.84934 8.31509C4.22495 8.31509 5.37271 7.34024 5.63986 6.04373C5.25916 6.67747 4.61624 7.09394 3.88724 7.09394C2.71824 7.09394 1.77051 6.02327 1.77051 4.70254C1.77051 3.80686 2.2064 3.02614 2.85153 2.61641H2.84934H2.84934ZM9.15066 3.68491C7.77505 3.68491 6.62729 4.65976 6.36014 5.95627C6.74084 5.32253 7.38376 4.90606 8.11276 4.90606C9.28176 4.90606 10.2295 5.97673 10.2295 7.29748C10.2295 8.19314 9.7936 8.97388 9.14847 9.38359H9.15066C10.7243 9.38359 12 8.10791 12 6.53425C12 4.9606 10.7243 3.68491 9.15066 3.68491ZM6.04373 6.36014C6.67748 6.74084 7.09395 7.38376 7.09395 8.11277C7.09395 9.28176 6.02327 10.2295 4.70253 10.2295C3.80686 10.2295 3.02613 9.7936 2.6164 9.14846V9.15066C2.6164 10.7243 3.8921 12 5.46575 12C7.0394 12 8.31509 10.7243 8.31509 9.15066C8.31509 7.77505 7.34024 6.62729 6.04373 6.36014Z"
        fill="#ADADAD"
      />
    </svg>
  )
}
